var map = {
	"./chat-icons/close.svg": "50e3",
	"./chat-icons/delete.svg": "2f0f",
	"./chat-icons/emoji.svg": "8595",
	"./chat-icons/like.svg": "e4fb",
	"./chat-icons/no-chat-messages.png": "ba77",
	"./chat-icons/reactions/angry.svg": "7551",
	"./chat-icons/reactions/astonished.svg": "093d",
	"./chat-icons/reactions/celebrate.svg": "9877",
	"./chat-icons/reactions/heart.svg": "834c",
	"./chat-icons/reactions/ok.svg": "6def",
	"./chat-icons/reactions/smile.svg": "6ee3",
	"./chat-icons/reply.svg": "c359",
	"./chat-icons/send.svg": "0a04",
	"./conferencing-icons/co-host.svg": "35b8",
	"./conferencing-icons/create-room.svg": "010e",
	"./conferencing-icons/fullscreen-close.svg": "0b8a",
	"./conferencing-icons/fullscreen.svg": "be03",
	"./conferencing-icons/pause.svg": "c1ce",
	"./conferencing-icons/play.svg": "687b",
	"./conferencing-icons/volume100.svg": "b5a3",
	"./conferencing-icons/volume25.svg": "5414",
	"./conferencing-icons/volume50.svg": "5948",
	"./conferencing-icons/volume75.svg": "c55c",
	"./conferencing-icons/volumemute.svg": "b0fe",
	"./css/global.css": "aede",
	"./css/video-js.css": "3c11",
	"./css/vue-tour.scss": "3b73",
	"./global-icons/add-gradient-circle.svg": "e2be",
	"./global-icons/add-green.svg": "07c1",
	"./global-icons/arrow-left-black.svg": "33a2",
	"./global-icons/arrow-right-white.svg": "4b84",
	"./global-icons/bin.svg": "d6e9",
	"./global-icons/clock.svg": "6b39",
	"./global-icons/copy.svg": "53db",
	"./global-icons/cross-red-circle.svg": "f149",
	"./global-icons/cross-red.svg": "26e3",
	"./global-icons/cross-white-circle.svg": "3779",
	"./global-icons/cross-white-small.svg": "dddc",
	"./global-icons/cross-white.svg": "e903",
	"./global-icons/download.svg": "d734",
	"./global-icons/edit.svg": "fa37",
	"./global-icons/email.svg": "01ab",
	"./global-icons/eye-hidden.svg": "1b6d",
	"./global-icons/eye-show-small-grey.png": "b106",
	"./global-icons/eye-show-small.svg": "357a",
	"./global-icons/eye-show.svg": "1110",
	"./global-icons/info.svg": "6f26",
	"./global-icons/jump-space.svg": "addf",
	"./global-icons/lightbulb.svg": "9d1e",
	"./global-icons/linkedin.svg": "4424",
	"./global-icons/lock.svg": "7024",
	"./global-icons/not-found-circles.svg": "bedf",
	"./global-icons/refresh.svg": "75aa",
	"./global-icons/spacein_logo_white.svg": "b230",
	"./global-icons/success.png": "f5ca",
	"./global-icons/upload-arrow.svg": "09cf",
	"./global-icons/upload-camera.svg": "b361",
	"./global-icons/user-circle.svg": "3db6",
	"./global-icons/user.svg": "bbaf",
	"./global-icons/warning.svg": "33e4",
	"./icons-library.pdf": "7c735",
	"./icons.svg": "d4d3",
	"./images/email-sent.svg": "7948",
	"./images/login.png": "24a9",
	"./images/not-found.svg": "c159",
	"./images/onboarding.png": "c4e3",
	"./images/participant.png": "fd41",
	"./images/spacein-intro.png": "beb0",
	"./notification-icons/announcement.png": "2cfc",
	"./notification-icons/broadcast.svg": "ebf4",
	"./notification-icons/camcorder-green.svg": "614c",
	"./notification-icons/camcorder-white.svg": "29b1",
	"./notification-icons/clear-notifications.svg": "be08",
	"./notification-icons/pin.svg": "55ec",
	"./notification-icons/pinned.svg": "b405",
	"./search-icons/search-placeholder.svg": "6d44",
	"./search-icons/search.svg": "61de",
	"./settings-icons/descending-arrow.svg": "b1cb",
	"./settings-icons/dropdown-arrow.svg": "4487",
	"./settings-icons/dropdown-tick.svg": "b1ed7",
	"./settings-icons/invite-user-green.svg": "55de",
	"./settings-icons/invite-user-white.svg": "0dfb",
	"./sidebar-icons/chat.svg": "36e3",
	"./sidebar-icons/close-arrow.svg": "3f7c",
	"./sidebar-icons/content.svg": "d3b6",
	"./sidebar-icons/exit-link-icon.svg": "8c15",
	"./sidebar-icons/help.svg": "7151",
	"./sidebar-icons/home.svg": "dc00",
	"./sidebar-icons/info.svg": "645f",
	"./sidebar-icons/menu-dots.svg": "cd07",
	"./sidebar-icons/notifications.svg": "eaa1",
	"./sidebar-icons/return.svg": "7c55",
	"./sidebar-icons/settings.svg": "aa47"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";